module.exports = __webpack_public_path__ + "static/media/rhino.19324828.usdz";